import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import BriefFormPopup from '../BriefFormPopup';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isBriefPopupOpen, setIsBriefPopupOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { name: 'Home', path: '/homepage', icon: 'Home' },
    { name: 'Case Studies', path: '/case-study', icon: 'FolderOpen' },
    { name: 'Courses', path: '/services', icon: 'Briefcase' },
    { name: 'Learning Process', path: '/process', icon: 'GitBranch' },
    { name: 'About', path: '/about', icon: 'Users' },
    { name: 'Contact', path: '/contact', icon: 'Mail' },
    { name: 'Contactv2', path: '/contactv2', icon: 'Mail' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleBriefPopupOpen = () => {
    setIsBriefPopupOpen(true);
  };

  const handleBriefPopupClose = () => {
    setIsBriefPopupOpen(false);
  };

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-background/95 backdrop-blur-sm border-b-2 border-concrete' : 'bg-background'
        }`}
      >
        <div className="w-full">
          <div className="flex items-center justify-between h-16 px-6 lg:px-8">
            {/* Logo */}
            <Link 
              to="/homepage" 
              className="flex items-center space-x-2 group"
              onClick={closeMobileMenu}
            >
              <div className="w-8 h-8 bg-black border-2 border-white transform group-hover:rotate-12 transition-transform duration-300">
                <div className="w-full h-full bg-white transform translate-x-1 translate-y-1 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-300"></div>
              </div>
              <span className="text-xl font-black text-primary tracking-tight">
                Semiconductor School
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`relative px-3 py-2 text-sm font-semibold transition-colors duration-300 group no-underline ${
                    isActivePath(item?.path)
                      ? 'text-primary' :'text-muted-foreground hover:text-primary'
                  }`}
                >
                  <span className="relative z-10">{item?.name}</span>
                  {isActivePath(item?.path) && (
                    <div className="absolute inset-0 bg-transparent transform -skew-x-12 scale-110"></div>
                  )}
                  <div className="absolute inset-0 bg-[#f4eedd] transform -skew-x-12 scale-0 group-hover:scale-110 transition-transform duration-300"></div>
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:block">
              <Button 
                variant="default" 
                onClick={handleBriefPopupOpen}
                className="text-primary font-bold border-2 brutalist-shadow hover:shadow-brutalist-sm transition-all duration-300"
                style={{ backgroundColor: '#f4eedd', borderColor: '#000000' }}
              >
                Start Your Cohort
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 text-primary hover:text-accent transition-colors duration-300"
              aria-label="Toggle mobile menu"
            >
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
            </button>
          </div>

          {/* Mobile Navigation */}
          <div className={`lg:hidden transition-all duration-300 ${
            isMobileMenuOpen
              ? 'max-h-screen opacity-100' :'max-h-0 opacity-0 overflow-hidden'
          }`}>
            <nav className="px-6 py-4 bg-card border-t-2 border-black">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-3 text-base font-medium transition-colors duration-300 border-b border-black last:border-b-0 ${
                    isActivePath(item?.path)
                      ? 'bg-accent text-accent-foreground'
                      : 'text-card-foreground hover:bg-concrete-light'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.name}</span>
                </Link>
              ))}

              <div className="pt-4 mt-4 border-t border-black">
                <Button
                  variant="default"
                  fullWidth
                  onClick={handleBriefPopupOpen}
                  className="text-primary font-bold border-2"
                  style={{ backgroundColor: '#f4eedd', borderColor: '#000000' }}
                >
                  Start Your Cohort
                </Button>
              </div>
            </nav>
          </div>
        </div>
      </header>

      {/* Brief Form Popup */}
      <BriefFormPopup 
        isOpen={isBriefPopupOpen}
        onClose={handleBriefPopupClose}
      />
    </>
  );
};

export default Header;